import { Controller } from '@hotwired/stimulus'
import { disableScroll, enableScroll } from '../utils/global'

// Подтверждение отправки формы модалкой в стиле сайта вместо нативного
// confirm(). Вешается на форму: перехватывает submit, подставляет тексты
// в общую модалку #tournament-confirm и отправляет форму только после
// явного «ОК». Тексты приходят через values из ui-переводов.
export default class ConfirmFormController extends Controller {
  static values = { title: String, message: String, ok: String }

  confirm(event) {
    if (this.approved) {
      this.approved = false
      return
    }

    const modal = document.getElementById('tournament-confirm')
    if (!modal) return // без модалки в DOM форма работает как обычно

    event.preventDefault()

    modal.querySelector('[data-confirm-title]').textContent = this.titleValue
    modal.querySelector('[data-confirm-message]').textContent =
      this.messageValue
    const okButton = modal.querySelector('[data-confirm-ok]')
    if (this.okValue) okButton.textContent = this.okValue

    const abort = new AbortController()
    const close = () => {
      modal.classList.remove('is-active')
      enableScroll()
      abort.abort()
    }

    okButton.addEventListener(
      'click',
      () => {
        close()
        this.approved = true
        this.element.requestSubmit()
      },
      { signal: abort.signal }
    )
    modal.querySelectorAll('[data-confirm-cancel]').forEach((el) => {
      el.addEventListener('click', close, { signal: abort.signal })
    })
    document.addEventListener(
      'keydown',
      (keyEvent) => {
        if (keyEvent.key === 'Escape') close()
      },
      { signal: abort.signal }
    )

    modal.classList.add('is-active')
    disableScroll()
    okButton.focus()
  }
}
